module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAABKCAMAAAC8X5WZAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMAeIfUED8c9erj3MuCSDg3KRZojZCSAAAAU0lEQVQ4y+3TOQ6AMBBDUU8mCfuW+x8WBU0RU4FEASi/e72NWayAnCTLXaBXImJHxNoSsTREjEz5CY8qP8yXDOkRxr7kpqmgV7rzcDr7DQZnTVk7KPsir2PzH3EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/q-right.png
// module id = UDhp
// module chunks = 0